import classNames from "classnames";
import styles from "./MaxWidthContainer.module.css";
import { CSSProperties, ReactNode } from "react";

//#region [Props]
export type SMaxWidthContainerProps = {
    $forContent?: boolean;
    className?: string;
    children?: ReactNode;
    style?: CSSProperties;
    as?: React.ElementType;
}
//#endregion


export default function SMaxWidthContainer({ $forContent, className, children, style, as: Tag = "div" }: SMaxWidthContainerProps) {
    return <Tag className={classNames(styles.MaxWidthContainer, $forContent ? styles.MaxWidthContainer_forContent : null, className)} style={style}>{children}</Tag>
}


//#endregion